function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Tabs, message, Skeleton, Button, Descriptions, Form, Modal, DatePicker, Input, Tag, Space } from 'antd';
import { Table } from 'react-bootstrap';
import { Search as SearchIcon, Eyedropper, BootstrapReboot, GraphUpArrow, Image, PencilSquare } from "react-bootstrap-icons";
import Common from "../components/includes/Common";
import PatientView from "../components/PatientView";
import SetImResult from "../components/forms/SetImResult";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Search = Input.Search;
var RangePicker = DatePicker.RangePicker;

var Imagerie = function Imagerie() {
  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      currentDept = _useState2[0],
      setCurrentDept = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      deptList = _useState4[0],
      setDeptList = _useState4[1];

  var _useState5 = useState(true),
      _useState6 = _slicedToArray(_useState5, 2),
      isDeptDataLoading = _useState6[0],
      setIsDeptDataLoading = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      queueData = _useState8[0],
      setQueueData = _useState8[1];

  var _useState9 = useState(null),
      _useState10 = _slicedToArray(_useState9, 2),
      currentQueueItem = _useState10[0],
      setCurrentQueueItem = _useState10[1];

  var _useState11 = useState(null),
      _useState12 = _slicedToArray(_useState11, 2),
      currentMedicalItem = _useState12[0],
      setCurrentMedicalItem = _useState12[1];

  var _useState13 = useState([]),
      _useState14 = _slicedToArray(_useState13, 2),
      sampledItems = _useState14[0],
      setSampledItems = _useState14[1];

  var _useState15 = useState(''),
      _useState16 = _slicedToArray(_useState15, 2),
      searchId = _useState16[0],
      setSearchId = _useState16[1];

  var _useState17 = useState(false),
      _useState18 = _slicedToArray(_useState17, 2),
      isResultModalOpen = _useState18[0],
      setIsResultModalOpen = _useState18[1];

  var _useState19 = useState(false),
      _useState20 = _slicedToArray(_useState19, 2),
      dataChanged = _useState20[0],
      setDataChanged = _useState20[1];

  var onSearch = function onSearch(v) {
    setSearchId('');

    if (v.length > 0) {
      setSearchId(v);
    }
  };

  var onSelectPeriodFinish = function onSelectPeriodFinish(values) {};

  useEffect(function () {
    setDataChanged(false);
    axios.get(Common.baseApiUrl + "getdepartments").then(function (response) {
      if (response.data.status == 200) {
        setDeptList(response.data.departments);
        var dep = response.data.departments.filter(function (d) {
          return d.label == 'IMAGERIE';
        });
        if (dep.length > 0) setCurrentDept(dep[0]);
        axios.get(Common.baseApiUrl + "getdailyqueue/" + dep[0].id.toString() + "/" + Common.currentUser.id).then(function (qresponse) {
          setQueueData(qresponse.data.queueItems);
        })["catch"](function (error) {
          message.error({
            content: "Une erreur est survenue",
            delay: 4
          });
        })["finally"](function () {
          setIsDeptDataLoading(false);
        });
        axios.get(Common.baseApiUrl + "getsampledqueue").then(function (sresponse) {
          if (sresponse.data.status == 200) {
            setSampledItems(sresponse.data.samples);
          }
        })["catch"](function (error) {})["finally"](function () {});
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {});
  }, [dataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsxs(Tabs, {
            animated: true,
            defaultActiveKey: 1,
            children: [/*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(Eyedropper, {
                  size: 30
                }), "Attente de resultat"]
              }),
              children: /*#__PURE__*/_jsxs("div", {
                className: "white-bg cool-radius",
                children: [/*#__PURE__*/_jsxs(Table, {
                  bordered: true,
                  responsive: true,
                  children: [/*#__PURE__*/_jsx("thead", {
                    children: /*#__PURE__*/_jsxs("tr", {
                      children: [/*#__PURE__*/_jsx("td", {
                        children: "Date"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Prenom"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Nom"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Telephone"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Examen(s)"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Saisir resultat"
                      })]
                    })
                  }), /*#__PURE__*/_jsx("tbody", {
                    children: queueData.length > 0 && queueData.filter(function (qd) {
                      return qd.status == 0;
                    }).map(function (q) {
                      return /*#__PURE__*/_jsxs("tr", {
                        children: [/*#__PURE__*/_jsx("td", {
                          children: new Date(q.created_at).toLocaleDateString('fr')
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.firstname
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.lastname
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.mobile.toString().slice(3)
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.queue_item_elements && q.queue_item_elements.map(function (e) {
                            return /*#__PURE__*/_jsx("li", {
                              children: /*#__PURE__*/_jsxs(Space, {
                                direction: "horizontal",
                                children: [/*#__PURE__*/_jsx("b", {
                                  children: e.business_account_medical_item.label
                                }), /*#__PURE__*/_jsx(Tag, {
                                  color: "#f50",
                                  children: e.business_account_medical_item.service.label
                                })]
                              })
                            }, e.id);
                          })
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Space, {
                            direction: "vertical",
                            children: q.queue_item_elements && q.queue_item_elements.map(function (e) {
                              return /*#__PURE__*/_jsx(Button, {
                                type: "primary",
                                onClick: function onClick() {
                                  setCurrentQueueItem(q);
                                  setCurrentMedicalItem(e.business_account_medical_item);
                                  setIsResultModalOpen(true);
                                },
                                size: "small",
                                children: e.business_account_medical_item.label
                              }, e.id);
                            })
                          })
                        })]
                      }, q.id);
                    })
                  })]
                }), /*#__PURE__*/_jsx("br", {}), isDeptDataLoading && /*#__PURE__*/_jsx(Skeleton, {
                  active: true
                })]
              })
            }, 1), /*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(BootstrapReboot, {
                  size: 30
                }), " R\xE9sultats"]
              }),
              children: /*#__PURE__*/_jsx("div", {
                className: "cool-radius white-bg",
                children: /*#__PURE__*/_jsxs(Table, {
                  bordered: true,
                  responsive: true,
                  children: [/*#__PURE__*/_jsx("thead", {
                    children: /*#__PURE__*/_jsxs("tr", {
                      children: [/*#__PURE__*/_jsx("td", {
                        children: "Date"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Prenom"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Nom"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "N.Echant."
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Examen(s) demand\xE9s"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Resultats"
                      }), /*#__PURE__*/_jsx("td", {})]
                    })
                  }), /*#__PURE__*/_jsx("tbody", {
                    children: sampledItems.map(function (s) {
                      return /*#__PURE__*/_jsxs("tr", {
                        children: [/*#__PURE__*/_jsx("td", {
                          children: new Date(s.created_at).toLocaleDateString('fr')
                        }), /*#__PURE__*/_jsx("td", {
                          children: s.customer.firstname
                        }), /*#__PURE__*/_jsx("td", {
                          children: s.customer.lastname
                        }), /*#__PURE__*/_jsx("td", {
                          children: s.sampleid
                        }), /*#__PURE__*/_jsx("td", {
                          children: s.queue_item.queue_item_elements.filter(function (item) {
                            return item.business_account_medical_item.service.id == s.service_id;
                          }).map(function (e) {
                            return /*#__PURE__*/_jsx(Tag, {
                              color: "red",
                              children: e.business_account_medical_item.label
                            }, e.id);
                          })
                        }), /*#__PURE__*/_jsx("td", {
                          children: s.laboratory_results.map(function (r) {
                            return /*#__PURE__*/_jsx("div", {
                              children: r.result_string
                            }, r.id);
                          })
                        }), /*#__PURE__*/_jsx("td", {})]
                      }, s.id);
                    })
                  })]
                })
              })
            }, 3), /*#__PURE__*/_jsxs(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(SearchIcon, {
                  size: 30
                }), " Recherche Patient"]
              }),
              children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Search, {
                placeholder: "Entrez ID ou Telephone",
                size: "large",
                onSearch: onSearch,
                enterButton: true,
                style: {
                  width: '100%',
                  marginBottom: '20px'
                }
              }), /*#__PURE__*/_jsx("br", {}), searchId.length > 0 && /*#__PURE__*/_jsx(PatientView, {
                pid: searchId
              })]
            }, 2), /*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(GraphUpArrow, {
                  size: 30
                }), " Activit\xE9s"]
              }),
              children: /*#__PURE__*/_jsx("div", {
                className: "cool-radius white-bg",
                style: {
                  minHeight: '300px'
                },
                children: /*#__PURE__*/_jsxs(Form, {
                  layout: "horizontal",
                  onFinish: onSelectPeriodFinish,
                  children: [/*#__PURE__*/_jsx(Form.Item, {
                    name: "perdiod",
                    rules: [{
                      required: true,
                      message: "Champ obligatoire"
                    }],
                    children: /*#__PURE__*/_jsx(RangePicker, {})
                  }), /*#__PURE__*/_jsx(Button, {
                    htmlType: "submit",
                    type: "primary",
                    children: "Chercher"
                  })]
                })
              })
            }, 4)]
          })
        })
      })
    }), /*#__PURE__*/_jsx(Modal, {
      open: isResultModalOpen,
      onCancel: function onCancel() {
        setIsResultModalOpen(false);
      },
      footer: null,
      width: "80%",
      title: /*#__PURE__*/_jsxs("b", {
        children: ["RESULTATS ", /*#__PURE__*/_jsx(Image, {
          size: 20
        })]
      }),
      children: currentQueueItem != null && /*#__PURE__*/_jsx(SetImResult, {
        q_item: currentQueueItem,
        m_item: currentMedicalItem
      })
    })]
  });
};

export default Imagerie;